var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.94999 0 0 4.95884 0 11.0663C0 16.5884 4.02599 21.1717 9.28399 22V14.2691H6.48999V11.0663H9.28399V8.6255C9.28399 5.85342 10.923 4.32932 13.442 4.32932C14.641 4.32932 15.895 4.53916 15.895 4.53916V7.26707H14.509C13.145 7.26707 12.716 8.11747 12.716 8.98996V11.0663H15.774L15.279 14.2691H12.716V22C15.3081 21.589 17.6684 20.2611 19.3709 18.2561C21.0734 16.2511 22.0059 13.701 22 11.0663C22 4.95884 17.05 0 11 0Z",
    fill: "#08BD80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFb);
export default __webpack_public_path__ + "static/media/ic_fb.b71071a1f386747a14f65e2b4e88964b.svg";
export { ForwardRef as ReactComponent };